import * as React from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { AppPath } from '@app/routes';
import { VideoModal } from '@atomic/obj.video-modal';
import { CircledLabel, ListCard } from '@atomic/v3';
import { montarAcoesMateriais } from './challenges-v3.actions';
import { ChallengesContainer, TarefasContainer } from './challenges-v3.component.style';
var resumoTarefas = function (quantidade) { return quantidade + " " + (quantidade === 1 ? 'tarefa' : 'tarefas'); };
// Mesmo comportamento do CoursePhaseList: tarefas abrem o aprendizado; PDF e vídeo como hoje.
export var ChallengePhaseListV3 = function (_a) {
    var course = _a.course;
    var history = useHistory();
    var _b = React.useState(null), selectedVideo = _b[0], setSelectedVideo = _b[1];
    var handleClick = function (task) {
        history.push({ pathname: "" + AppPath.Learning, state: { quiz: task, hideBackToQuizButton: true } });
    };
    return (React.createElement(ChallengesContainer, null,
        selectedVideo && React.createElement(VideoModal, { videoURL: selectedVideo, opened: true, onClose: function () { return setSelectedVideo(null); } }),
        course.fases.map(function (phase, idxPhase) {
            var _a;
            return (React.createElement(React.Fragment, { key: phase.id },
                React.createElement(ListCard, { leading: React.createElement(CircledLabel, { label: "F." + (idxPhase + 1) }), title: phase.titulo, subtitle: resumoTarefas(phase.tarefas.length), actions: montarAcoesMateriais({ pdfUrl: (_a = phase === null || phase === void 0 ? void 0 : phase.arquivo) === null || _a === void 0 ? void 0 : _a.url, rotuloPdf: 'Abrir PDF da fase' }) }),
                React.createElement(TarefasContainer, null, phase.tarefas.map(function (task, idxTask) {
                    var _a, _b;
                    return (React.createElement(ListCard, { key: idxTask, compacto: true, leading: React.createElement(CircledLabel, { label: "T." + (idxTask + 1), size: "small" }), title: task.nome, trailing: React.createElement(FaChevronRight, null), onClick: function () { return handleClick(task); }, actions: montarAcoesMateriais({
                            pdfUrl: (_a = task === null || task === void 0 ? void 0 : task.arquivo) === null || _a === void 0 ? void 0 : _a.url,
                            onAssistirVideo: ((_b = task === null || task === void 0 ? void 0 : task.video) === null || _b === void 0 ? void 0 : _b.url) ? function () { return setSelectedVideo(task.video.url); } : undefined,
                        }) }));
                }))));
        })));
};
